import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccountService } from '../../core/services/account.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-verify-user',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './verify-user.component.html',
  styleUrls: ['./verify-user.component.scss']
})
export class VerifyUserComponent implements OnInit{
  message: string = '';
  loading: boolean = true;
  success: boolean = false;
  linkExpired = false;

  constructor(
    private route: ActivatedRoute,
    private accountService: AccountService
  ) {}

  ngOnInit(): void {
    const token = this.route.snapshot.queryParamMap.get('token');

    if (token) {
      this.accountService.verifyUser(token).subscribe({
        next: (response) => {
          this.success = response.success;
          this.message = response.message;
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.success = false;

          if (err.status === 410) {
            this.linkExpired = true;
            this.message = err.error?.message || 'El enlace ya no es válido';
          } else {
            this.message = err.error?.message || 'Error al verificar el usuario';
          }
        }
      });
    } else {
      this.success = false;
      this.message = 'Token inválido o no proporcionado.';
      this.loading = false;
    }
  }

 }